import React, { useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux"
import { authActions } from '../store';
import { getRedirectUri } from '../utils/auth';
import {useTranslation} from "react-i18next";
import {LogoMarkUpdated} from "../vectorImages/LogoMarkUpdated"

const Oauth = () => {
    const location = useLocation();
    const dispatch = useDispatch()
    const queryParams = new URLSearchParams(location.search);
    const {t} = useTranslation();
    // access query parameters
    const provider = queryParams.get("provider");
    const code = queryParams.get("code");
    const state = queryParams.get("state");


    const refer = useRef(true);

    useEffect(() => {
        if (refer.current) {
            refer.current = false;
            dispatch(authActions.oauth({ provider: provider || state, code, redirectUrl: getRedirectUri(provider) }));
        }
    })

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-6">
                <LogoMarkUpdated size={300}/>
                <div
                    className="h-10 w-10 rounded-full border-4 border-gray-300 border-t-black animate-spin"
                    aria-label="loading"
                    role="status"
                />
                <p className="text-sm text-gray-500">{t("signin.login")}</p>
            </div>
        </div>
    );
};

export default Oauth;
